import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Form from 'components/form/Form';
import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const PriceCalculatorContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow: auto;

	.bottomProgress {
		margin-top: -1rem;
		margin-bottom: 2rem;
	}
`;

export const StyledPriceCalculatorForm = styled(Form)`
	height: 100%;
`;

export const ShippingDetailsTabContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		gap: unset;
	}
`;

export const ShippingSuccessCard = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;

	.lottie {
		height: 20dvh !important;
	}
`;

export const ShippingSuccessCardContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	width: 100%;
	padding: 0 2rem;
	overflow: auto;
`;

export const ShippingSuccessTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

export const ShippingSuccessGuidesContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 90rem;
	border-radius: var(--spacing-3);
	border: 1px solid var(--border-color);
	margin-top: 3rem;
`;

export const ShippingSuccessGuidesHeader = styled.div`
	display: flex;
	flex-direction: row;
	padding: 1rem 2rem;
	background-color: var(--background-1);
	border-radius: var(--spacing-3);
	border-bottom: 1px solid var(--border-color);
`;

export const ShippingFromContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	flex: 1 0 auto;
`;

export const ShippingCompanyLogoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	position: relative;
	margin: 0 1rem;

	> img {
		z-index: 1;
	}
`;

export const ShippingToContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	flex: 1 0 auto;
`;

export const ShippingCompanyLogoDashedLine = styled.div`
	position: absolute;
	top: 3rem;
	right: 0;
	width: 100%;
	height: 0;
	border-top: 1px dashed var(--black-30);

	body[dir='rtl'] & {
		right: unset;
		left: 0;
	}
`;

export const ShippingCompanyLogoLeftDot = styled.div`
	position: absolute;
	top: 2.5rem;
	left: 0;
	width: 1rem;
	height: 1rem;
	border-radius: 50%;
	background-color: var(--black-30);

	body[dir='rtl'] & {
		left: unset;
		right: 0;
	}
`;

export const ShippingCompanyLogoRightDot = styled.div`
	position: absolute;
	top: 2.5rem;
	right: 0;
	width: 1rem;
	height: 1rem;
	border-radius: 50%;
	background-color: var(--black-30);

	body[dir='rtl'] & {
		right: unset;
		left: 0;
	}
`;

export const ShippingSuccessGuidesContent = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
`;

export const ShippingSuccessGuidesContentDashedLine = styled.div`
	position: absolute;
	height: calc(100% - 10rem);
	border-right: 1px dashed var(--content-2);
	left: 3rem;
	bottom: 1rem;

	body[dir='rtl'] & {
		left: unset;
		right: 3rem;
	}
`;

export const ShippingSuccessGuides = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const ShippingSuccessGuideItem = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 3rem;
	gap: 2rem;

	> img {
		z-index: 1;
	}
`;

export const ShippingSuccessGuideItemRightContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const ShippingSuccessGuideItemTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
`;

export const ShippingSuccessGuideItemLinkContainer = styled.div`
	display: flex;
	align-items: flex-end;
	padding: 1rem 0;
`;

export const ShippingSuccessButtonContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
	align-items: flex-end;
	gap: 1rem;
	padding: 2rem;
	border-top: 1px solid var(--border-color);
`;

export const ShippingDocumentsAndPickupOptionsCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 0;
	overflow: unset;
	max-height: unset;
	&.my-2-5 {
		margin: 2.5rem 0;
	}
`;

export const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2.5rem;
	gap: 4rem;
	overflow: auto;
`;

export const ShippingDocumentsAndPickupOptionsButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: 2rem;
	gap: 1rem;
	box-shadow: 0px 1px 0px 0px var(--border-color) inset;
	body[dir='rtl'] & {
		> button > .button-icon {
			transform: scaleX(-1);
		}
	}
`;

export const ShippingDocumentsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;

	> .form-item {
		padding: 0;

		.form-item-content {
			display: flex;
			flex-direction: row;
			gap: 2rem;

			> div {
				width: 40rem;
			}

			@media ${Breakpoints.mobile} {
				flex-direction: column;
			}
		}
	}
`;

export const Line = styled.span`
	border-top: 1px solid var(--border-color);
`;

export const PickupOptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const PickupOptionsButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 2rem;

	img {
		height: 59px !important;
		width: inherit !important;
	}
	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const Divider = styled.div`
	display: flex;
	height: 1px;
	width: 100%;
	background-color: var(--border-color);
`;

export const PackageSelectionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	width: 100%;
	gap: 2rem;

	@media ${Breakpoints.mobileLandscape} {
		align-items: stretch;
		padding: 1rem;
	}
`;

export const PackageButton = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	padding: 2rem 5rem;
	border: 1px solid var(--border-color) !important;
	gap: 1.5rem;
	background-color: var(--white) !important;
	&.selected {
		border-color: var(--blue) !important;
		background-color: var(--table-selected-color) !important;
	}

	:hover {
		background-color: var(--background-1) !important;
	}

	@media ${Breakpoints.mobileLandscape} {
		align-items: flex-start;
		flex-direction: column;
		gap: 0.5rem;
	}
`;

export const PackageButtonTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	overflow: auto;

	@media ${Breakpoints.mobileLandscape} {
		align-items: flex-start;
	}
`;

export const PackageButtonTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;

	.badge {
		background-color: var(--blue) !important;
		padding: 1rem 0.5rem !important;

		> .typography {
			color: var(--alwaysWhiteColor);
			font-weight: 500;
			font-size: 1.08rem;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		align-items: flex-start;
		/* flex-direction: column; */
		gap: 0.5rem;
	}
`;

export const BlackText = styled.span`
	color: var(--black);
	font-weight: 500;
`;

export const InstructionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.581rem;
	padding: 0 var(--padding-2);
`;

export const InstructionRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-top: var(--margin-2);

	.status {
		margin: var(--margin-1);
	}

	.instruction-number {
		min-width: 3rem;
		height: 3rem;
		border-radius: 50%;
		background-color: var(--black-10);
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const InstructionColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--margin-2);
	width: 100%;

	.instruction-detail {
		line-height: 3rem;
	}
`;

export const Flex = styled.div`
	display: flex;
	flex-direction: row;
	gap: var(--margin-2);
	align-items: center;
`;
export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	gap: 0.7rem;

	input[type='checkbox'] {
		min-width: 2rem;
	}

	.read-instructions {
		color: ${({ hasError }) => (hasError ? 'var(--red)' : 'var(--content-3)')};
	}
`;

export const ShippingCheckoutRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	justify-content: space-between;
	background-color: var(--white);
	padding: 2rem 2.5rem;

	.indent {
		text-indent: 1.5rem;
	}

	&.bold-container {
		background-color: var(--background-3);
	}
`;

export const OTOCreditTextBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: flex-end;
`;

export const ShippingCheckoutRowText = styled.div`
	display: flex;
	align-items: center;
	font-size: var(--paragraph3-font-size);
	font-weight: 500;
	.typography .modal-button {
		padding: 0;
	}
	.bold-price {
		font-weight: 500;
		font-size: var(--paragraph3-font-size);
		color: var(--black);
	}
`;

export const ShippingInformationCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 0;
	flex: 1 0 auto;

	&.doNotDisplay {
		display: none;
	}
`;

export const ShippingDocumentsAndPickupOptionsButtonsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 2.5rem;
	gap: 1rem;
	box-shadow: 0px 1px 0px 0px var(--border-color) inset;
	position: sticky;
	bottom: 0;
	background-color: var(--white);
	body[dir='rtl'] & {
		> button > .button-icon {
			transform: scaleX(-1);
		}
	}
`;

export const ShippingCheckoutContainer = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 0;
	border: none !important;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	border-top: none;
	flex-direction: row;
	justify-content: end;
	gap: 1rem;
	border: none;
	border-top: 0;
	gap: var(--margin-2);
	min-height: fit-content;

	body[dir='rtl'] & {
		justify-content: left;

		.icon {
			transform: scaleX(-1);
		}
	}
`;

export const ShippingCheckoutLogoWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	position: relative;
	gap: 1rem;
`;

export const ModalButton = styled(Button)`
	display: inline-block;
`;
